<template>
  <div
    class="navbar-container d-flex align-items-center justify-content-between flex-wrap flex-md-nowrap"
  >
    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none navbar-menu-toggle">
      <li class="nav-item">
        <b-link class="nav-link" @click="toggleVerticalMenuActive">
          <feather-icon icon="MenuIcon" size="21" />
        </b-link>
      </li>
    </ul>

    <!-- Left Col d-none  -->
    <div
      v-if="activeUserRole"
      class="bookmark-wrapper align-items-center flex-grow-1 d-flex navbar-company-wrapper"
    >
      <v-select
        input-id="company"
        ref="company"
        v-model="guidCompany"
        :options="companyList"
        label="name"
        :placeholder="$t('navbar.selectCompany')"
        :no-drop="loadingCompanies"
        :loading="loadingCompanies"
        :reduce="(option) => option.guid"
        @input="companyChanged"
        class="navbar-company-select"
      >
        <!-- button-content-main  -->
        <template #selected-option="{ name }">
          <span class="navbar-company-select__value" :title="name">
            {{ name }}
          </span>
        </template>

        <template #option="{ name }">
          <span class="navbar-company-select__option" :title="name">
            {{ name }}
          </span>
        </template>

        <!-- <template #no-options>
          <span class="navbar-company-select__empty">
            {{
              loadingCompanies
                ? $t("navbar.loadingCompanies")
                : companyLoadError
                ? $t("navbar.companyLoadError")
                : $t("navbar.noCompanies")
            }}
          </span>
        </template> -->
      </v-select>
      <!-- Bookmarks Container -->
    </div>

    <div
      v-else
      class="bookmark-wrapper align-items-center flex-grow-1 d-flex navbar-company-wrapper"
    >
      <!-- <p class="mr-1 mb-0" style="opacity: 0.6">{{ `${$t('pages.companies.form.label.dollarRate')}:` }}</p>
      <b-form-input input-id="company" ref="company" label="name"
        :placeholder="$t('pages.companies.form.label.dollarRate')"
        class="button-content-main text-primary font-weight-bolder">
      </b-form-input> -->

      <div class="d-flex align-items-center mr-2 navbar-rate-control">
        <b-form-group class="mb-0" v-if="dollarRate !== null">
          <b-input-group class="input-group-merge">
            <b-form-input
              type="number"
              :disabled="!editingRate"
              v-model="dollarRate"
              :placeholder="$t('pages.companies.form.label.dollarRate')"
              class="text-primary font-weight-bolder"
            />
            <b-input-group-append is-text>
              <feather-icon
                v-if="!editingRate"
                v-b-tooltip.hover.bottom="$t('pages.companies.editDollarRate')"
                icon="Edit2Icon"
                class="cursor-pointer"
                @click="toEditRate"
              />
              <feather-icon
                v-else
                v-b-tooltip.hover.bottom="$t('pages.companies.editDollarRate')"
                icon="CheckIcon"
                class="cursor-pointer"
                @click="editDollarRate"
              />
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
        <!-- <span v-else class="navbar-empty-text">
          {{ $t("navbar.selectCompany") }}
        </span> -->
      </div>

      <span
        class="text-nowrap d-none d-md-block"
        style="opacity: 0.6; font-size: 0.9rem"
      >
        {{ $t("pages.companies.form.label.dollarRate") }}
      </span>

      <!-- Bookmarks Container -->
    </div>

    <b-navbar-nav class="nav align-items-center ml-auto navbar-actions-wrapper">
      <div class="d-flex align-items-center navbar-actions-inner">
        <b-badge
          pill
          :variant="tagsColor(isEndDateBeforeToday(membershipData.endDate))"
          v-if="membershipData != null && isCompany"
          class="text-nowrap"
          style="font-size: 0.8rem"
        >
          <span class="badge-text">
            {{
              isStartDateAfterToday(membershipData.startDate)
                ? "Validación de pago"
                : membershipStatus()
            }}
          </span>
        </b-badge>
        <!-- <notification-dropdown v-if="!activeUserRole"></notification-dropdown> -->
        <locale />
        <user-dropdown />
      </div>
    </b-navbar-nav>
  </div>
</template>

<script>
import _ from "lodash";
import {
  BLink,
  BNavbarNav,
  BRow,
  BCol,
  BBadge,
  BFormInput,
  BFormGroup,
  BInputGroup,
  BInputGroupAppend,
  VBTooltip,
} from "bootstrap-vue";
import Locale from "./components/Locale.vue";
import UserDropdown from "./components/UserDropdown.vue";
import NotificationDropdown from "./components/NotificationDropdown.vue";
import vSelect from "vue-select";
import { getParams } from "@core/utils/utils";
import { allCompanies, updateRate } from "@core/api/request/company";
import store from "@/store";
import { getUserRole } from "@/auth/utils";
import { getCookie, setCookie } from "@/auth/CookiesManager";
import { allMembershipsOfcompany } from "@core/api/request/membership";
// import { getSubcription } from "@/@core/api/request";

export default {
  components: {
    BLink,

    // Navbar Components
    BNavbarNav,
    Locale,
    UserDropdown,
    NotificationDropdown,
    BRow,
    BCol,
    vSelect,
    BBadge,
    BFormInput,
    BFormGroup,
    BInputGroup,
    BInputGroupAppend,
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
  data: () => ({
    guidCompany: "",
    companyList: [],
    dollarRate: null,
    dolarBCV: null,
    editingRate: false,
    membershipData: null,
    isCompany: false,
    loadingCompanies: false,
    loadingMembership: false,
    companyLoadError: false,
  }),
  create() {},
  computed: {
    activeUserRole() {
      const role = this.$store.state.appConfig.role;
      return ["BACKOFFICE"].includes(role);
    },

    selectedCompanyLabel() {
      const company = this.companyList.find(
        (item) => item.guid === this.guidCompany,
      );
      return company ? company.name : this.$t("navbar.selectCompany");
    },
  },
  async mounted() {
    const user = this.$store.state.appConfig;
    this.guidCompany =
      this.$store.getters["appConfig/effectiveCompanyGuid"];
    this.getCompanies();

    if (!["BACKOFFICE"].includes(user.role)) {
      if (!user.activeCompanyGuid && this.guidCompany) {
        store.commit("appConfig/SET_ACTIVE_COMPANY", this.guidCompany);
      }

      this.dollarRate = user.sessionContext?.tasaDolar ?? null;
      this.dolarBCV =
        user.sessionContext?.dolarBCV ?? user.dolarBCV ?? null;
      await this.getSubcription();
      this.isCompany = true;
    }
  },

  methods: {
    async editDollarRate() {
      let ratePayload = {
        guidCompany: this.guidCompany,
        tasaDolar: this.dollarRate,
      };

      let rateResponse = await updateRate(ratePayload);

      if (rateResponse.err) {
        this.alertToast("danger", `Alerta codigo`, error.message);
      } else {
        this.alertToast(
          "success",
          this.$t("registerSuccess"),
          this.$t("pages.companies.editDollarSuccess"),
        );
        this.editingRate = false;
      }
    },

    toEditRate() {
      this.editingRate = true;
    },

    label(field) {
      return `pages.orders.form.label.${field}`;
    },
    tagsColor(status) {
      return status ? "light-success" : "light-danger";
    },
    isEndDateBeforeToday(endDateString) {
      const endDate = new Date(endDateString);

      const today = new Date();
      today.setHours(0, 0, 0, 0);

      endDate.setHours(0, 0, 0, 0);

      return today < endDate;
    },
    isStartDateAfterToday(startDateString) {
      if (!startDateString) return false;
      const startDate = new Date(startDateString);
      if (isNaN(startDate)) return false;

      const today = new Date();
      today.setHours(0, 0, 0, 0);
      startDate.setHours(0, 0, 0, 0);

      return startDate > today;
    },
    membershipStatus() {
      const today = new Date();
      const endDate = new Date(this.membershipData.endDate);

      if (endDate < today) {
        const daysOverdue = Math.round(
          (today - endDate) / (1000 * 60 * 60 * 24),
        );
        return `Vencida hace ${daysOverdue} días`;
      } else {
        const daysRemaining = Math.round(
          (endDate - today) / (1000 * 60 * 60 * 24),
        );
        return `Vigente por ${daysRemaining} días`;
      }
    },
    getCompanies() {
      this.loadingCompanies = true;
      this.companyLoadError = false;

      const param = getParams(["page,1", "rows,999"]);
      allCompanies(param)
        .then((resp) => {
          const data = _.get(resp, "data") || [];
          this.companyList = _.map(data.items, (company) => {
            return {
              guid: company.guid,
              name: company.name,
              dollarRate: company.tasaDolar,
              nameCoinType: company.companyType
                ? company.companyType.nameCoinType
                : company.nameCoinType || null,
              dolarBCV: company.dolarBCV,
              iva: company.iva,
              idCompany: company.idCompany,
              idCatType:
                company?.companyType?.idCatType ?? company?.idCatType ?? null,
            };
          });
        })
        .catch((error) => {
          this.companyLoadError = true;
          this.companyList = [];

          this.alertToast(
            "danger",
            this.$t("Error"),
            _.get(error, "data.message", this.$t("navbar.companyLoadError")),
          );
        })
        .finally(() => {
          this.loadingCompanies = false;

          let currentCompany = this.companyList.find(
            (element) => element.guid == this.guidCompany,
          );
          if (!!currentCompany) {
            this.dollarRate = currentCompany.dollarRate;
            this.dolarBCV = currentCompany.dolarBCV;
            // setCookie("dolarBCV", this.dolarBCV, 1);
            store.commit("appConfig/SET_DOLARBCV", this.dolarBCV);
            store.commit("appConfig/SET_DIVISA", currentCompany.nameCoinType);
            store.commit("appConfig/SET_IVA", currentCompany.iva);
          } else {
            this.clearActiveTenant();
          }
        });
    },

    async getSubcription() {
      await allMembershipsOfcompany(this.guidCompany)
        .then((resp) => {
          const data = _.get(resp, "data");
          this.membershipData = data;
        })
        .catch((error) => {
          console.log("error", error);
          this.loading = !this.loading;
          this.membershipData = "";
          this.alertToast(
            "danger",
            this.$t("Error"),
            _.get(
              error,
              "data.message",
              this.$t("landing.contact.errorMessage"),
            ),
          );
        })
        .finally(() => {
          this.loadingMembership = false;
        });
    },

    companyChanged(companyId) {
      const company = _.find(
        this.companyList,
        (model) => model.guid === companyId,
      );

      if (!company) {
        this.clearActiveTenant();
        return;
      }

      this.guidCompany = companyId;
      this.dollarRate = company.dollarRate ?? "";
      this.dolarBCV = company.dolarBCV ?? "";
      store.commit("appConfig/SET_ACTIVE_COMPANY", companyId);
      store.commit("appConfig/SET_DOLARBCV", company.dolarBCV);
      store.commit("appConfig/SET_DIVISA", company.nameCoinType);
      store.commit("appConfig/SET_IVA", company.iva);
      store.commit("appConfig/SET_ID_COMPANY", company.idCompany);
      // store.commit("appConfig/SET_ACTIVE_ID_CAT_TYPE", company.idCatType);
    },

    clearActiveTenant() {
      if (!this.activeUserRole) {
        const ownCompanyGuid =
          this.$store.state.appConfig.sessionContext?.activeCompanyGuid ?? null;

        this.guidCompany = ownCompanyGuid;
        if (ownCompanyGuid) {
          store.commit("appConfig/SET_ACTIVE_COMPANY", ownCompanyGuid);
        }
        return;
      }

      this.guidCompany = null;
      this.dollarRate = null;
      this.dolarBCV = null;

      store.commit("appConfig/CLEAR_ACTIVE_COMPANY");
    },

    alertToast(type = null, title = null, message = null) {
      this.$bvToast.toast(message, {
        title,
        variant: type,
        solid: true,
        icon: "CoffeeIcon",
      });
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
<style lang="scss" scoped>
.navbar-container {
  column-gap: 0.75rem;
}

.navbar-menu-toggle {
  flex: 0 0 auto;
}

.navbar-company-wrapper {
  min-width: 150px;
  max-width: 220px;
  margin-right: 0.75rem;
}

.navbar-actions-wrapper {
  margin-left: auto;
  flex: 0 0 auto;
}

.navbar-actions-inner {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.navbar-actions-inner > * {
  margin: 0;
}

.navbar-actions-inner .dropdown-language {
  margin-right: 0.1rem;
}

.navbar-actions-inner .badge {
  margin-right: 0.1rem;
}

.navbar-company-select {
  width: 100%;
  min-width: 150px;
  max-width: 220px;
}

.navbar-company-select ::v-deep .vs__dropdown-toggle {
  min-height: 40px;
  padding: 0 0.35rem;
  border-radius: 12px;
  border-color: #d9d6e5;
  background-color: #fff;
  box-shadow: none;
}

.navbar-company-select ::v-deep .vs__selected-options {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  min-width: 0;
  padding-left: 0.2rem;
}

.navbar-company-select ::v-deep .vs__selected {
  margin: 0;
  max-width: 100%;
  padding: 0;
}

.navbar-company-select ::v-deep .vs__search,
.navbar-company-select ::v-deep .vs__search::placeholder {
  font-size: 0.95rem;
  color: #6e6b7b;
}

.navbar-company-select ::v-deep .vs__actions {
  padding-right: 0.25rem;
}

.navbar-company-select ::v-deep .vs__clear,
.navbar-company-select ::v-deep .vs__open-indicator {
  transform: scale(0.95);
}

.navbar-company-select ::v-deep .vs__dropdown-menu {
  margin-top: 0.4rem;
  border-radius: 14px;
  border: 1px solid rgba(34, 41, 47, 0.08);
  box-shadow: 0 12px 28px rgba(34, 41, 47, 0.12);
  padding: 0.35rem;
}

.navbar-company-select ::v-deep .vs__dropdown-option {
  padding: 0;
  border-radius: 10px;
}

.navbar-company-select ::v-deep .vs__dropdown-option--highlight {
  background: rgba(40, 169, 224, 0.12);
  color: #1a7bbd;
}

.navbar-company-select__value {
  display: block;
  max-width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 0.9rem;
  font-weight: 500;
  line-height: 1.2;
  color: #5e5873;
}

.navbar-company-select__option {
  display: block;
  width: 100%;
  padding: 0.7rem 0.85rem;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 0.9rem;
  color: #5e5873;
}

.navbar-company-select__empty {
  display: block;
  padding: 0.7rem 0.85rem;
  font-size: 0.9rem;
  color: #8d89a3;
}

.navbar-empty-text {
  font-size: 0.9rem;
  opacity: 0.7;
  white-space: nowrap;
}

@media (max-width: 767.98px) {
  .navbar-container {
    row-gap: 0.5rem;
    column-gap: 0.5rem;
    align-items: center !important;
  }

  .navbar-menu-toggle {
    order: 1;
  }

  .navbar-company-wrapper {
    order: 3;
    flex: 0 0 100%;
    min-width: 100%;
    max-width: 100%;
    margin-right: 0;
  }

  .navbar-rate-control {
    width: 100%;
    margin-right: 0 !important;
  }

  .navbar-rate-control .form-group,
  .navbar-rate-control .input-group {
    width: 100%;
  }

  .navbar-actions-wrapper {
    order: 2;
    min-width: 0;
    margin-left: auto !important;
  }

  .navbar-actions-inner {
    justify-content: flex-end;
    gap: 0.35rem;
  }

  .navbar-company-select {
    min-width: 100%;
    max-width: 100%;
  }

  .navbar-company-select ::v-deep .vs__dropdown-toggle {
    min-height: 42px;
  }

  .navbar-company-select ::v-deep .vs__search,
  .navbar-company-select ::v-deep .vs__search::placeholder {
    font-size: 0.95rem;
  }

  .navbar-company-select__value,
  .navbar-company-select__option {
    font-size: 0.92rem;
  }
}
</style>
